import { castArray } from 'lodash-es';
import React from 'react';
import Thumbnail, { ThumbnailProps } from 'components/Thumbnail';
import ThumbnailStack, { ThumbnailStackProps } from 'components/ThumbnailStack';
import * as S from './styles';

export type DescriptionThumbnailProps = Pick<
  ThumbnailProps,
  'ratio' | 'objectFit' | 'alt'
> &
  Pick<ThumbnailStackProps, 'src'> & {
    className?: string;
  };

function isStack(
  src: DescriptionThumbnailProps['src'],
): src is [string, string, string?] {
  if (typeof src === 'string') {
    return false;
  }

  if (src.length === 1) {
    return false;
  }

  return true;
}

const DescriptionThumbnail: React.FC<DescriptionThumbnailProps> = ({
  alt,
  className,
  objectFit,
  ratio,
  src,
}) => {
  const thumbnailProps = {
    alt,
    basis: ratio < 1 ? 'height' : 'width',
    objectFit,
    ratio,
  };

  return (
    <S.ThumbnailContainer className={className}>
      {isStack(src) ? (
        <S.Thumbnail as={ThumbnailStack} src={src} {...thumbnailProps} />
      ) : (
        <S.Thumbnail
          as={Thumbnail}
          src={castArray(src)[0]}
          {...thumbnailProps}
        />
      )}
    </S.ThumbnailContainer>
  );
};

export default DescriptionThumbnail;
